import { IPublicClientApplication } from '@azure/msal-browser'
import { protectedResources } from '../authConfig'
import { authorizedPost } from '../utils/authUtils'

interface SasTokenRequest {
  containerName: string
  blobName: string
}

interface SasTokenResponse {
  sasToken: string
  blobUrl: string
  expiresAt: string
}

const baseUrl = process.env.REACT_APP_BASE_API_URL

export const getSasToken = async (
  instance: IPublicClientApplication,
  containerName: string,
  blobName: string,
): Promise<SasTokenResponse> => {
  const sasRequest: SasTokenRequest = {
    containerName,
    blobName,
  }

  return await authorizedPost<SasTokenResponse>(
    instance,
    `${baseUrl}/azure/sas-token`,
    sasRequest,
    protectedResources.scopes.read,
  )
}
